import { Component } from "react";

class ServiceBase extends Component {

  state = {
    error: null
  }

  getFilter(filter) {
    let situacao = filter && filter.situacao ? "situacao eq '" + filter.situacao + "'" : null;
    let filters = filter && filter.filters ? filter.filters : null;
    let campo = filter && filter.campo ? filter.campo : null;
    let campoTraducao = filter && filter.campoTraducao ? filter.campoTraducao : null;
    let operacao = filter && filter.operacao ? filter.operacao : null;
    let valor = filter && filter.valor
    ?
    (typeof (filter.valor) === 'string')
      ? filter.valor.replaceAll('%', '%25')
      : filter.valor
    : null;

    let retorno = "";

    if (filters) {
      retorno = `?$filter=${filters}`;
    } else if (situacao) {
      retorno = `?$filter=${situacao}`;
    }
  
    if (campo && operacao && valor) {
      let filtro = ""
      let operacaoFiltro = "";
      if (operacao === 'Contains') {
        operacaoFiltro = `Contains(${campo},'${valor}')`;
        if (campoTraducao) {
          operacaoFiltro = `${operacaoFiltro} or Contains(${campoTraducao},'${valor}')`;
        }
      } else if (operacao === 'StartsWith') {
        operacaoFiltro = `StartsWith(${campo},'${valor}')`;
        if (campoTraducao) {
          operacaoFiltro = `${operacaoFiltro} or StartsWith(${campoTraducao},'${valor}')`;
        }
      } else {
        operacaoFiltro = `${campo} ${operacao} '${valor}'`;
        if (campoTraducao) {
          operacaoFiltro = `(${operacaoFiltro}) or (${campoTraducao} ${operacao} '${valor}')`;
        }
      }

      filtro = `?$filter=${operacaoFiltro}`;
  
      if (situacao) {
        filtro += ` and ${situacao} `;
      }
      if(filters) {
        filtro += ` and ${filters} `;
      }
      retorno = filtro ;
    }
  
    if (filter.page > 1) {
      retorno = retorno === "" ? "?" : retorno + "&";
      retorno = retorno + "$page=" + filter.page;
    }
    if (retorno === "" ) {
      retorno = "?$top=10";
    }
   
    const campoorder = filter.campoorder ?? null;
    const tipoorder = filter.tipoorder ?? null;

    retorno = campoorder ? `${retorno}&$orderby=${campoorder} ${tipoorder}` : retorno;

    return retorno;
  }

  SetError(error) {
    this.setState({
      error: error
    })
  }

  ClearError() {
    this.setState({
      error: null
    })
  }

}

export default ServiceBase;